import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { fetchCapabilities } from 'flow/actions/app-actions';
import Loading from 'flow/components/ui-components/Loading';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import {
    selectCapabilitiesLoaded,
    selectHasTranscriptionCapabilityBusinessOrPersonal,
} from 'flow/selectors/own-extension-selectors';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

/**
 * Resolves the generic Call Digest email link (/settings/account/transcriptions)
 * to the signed-in user's transcription settings page. The email-rendering server
 * doesn't know each recipient's extension id, so we fill it in here.
 *
 * If the user lacks any transcription capability, redirect to the settings root
 * instead of landing on an empty page.
 */
const CallDigestTranscriptionsRedirect = () => {
    const dispatch = useAppDispatch();
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const capabilitiesLoaded = useAppSelector(selectCapabilitiesLoaded);
    const hasTranscriptionCapability = useAppSelector(
        selectHasTranscriptionCapabilityBusinessOrPersonal,
    );

    useEffect(() => {
        if (!capabilitiesLoaded) {
            dispatch(fetchCapabilities);
        }
    }, [dispatch, capabilitiesLoaded]);

    if (!ownExtensionKey || !capabilitiesLoaded) {
        return <Loading />;
    }

    const target = hasTranscriptionCapability
        ? generatePath(routes['settings.transcriptions'], {
              extensionKey: ownExtensionKey,
          })
        : generatePath(routes['settings'], {
              extensionKey: ownExtensionKey,
          });

    return <Redirect to={target} />;
};

export default CallDigestTranscriptionsRedirect;
